import { ApplicationDetails, ApplicationInspection } from "../Components/Home/ApplicationDetails.types";
import { DateFormat, Tag, TagColumnFilter } from "@fdoh/health-react";
import { Link, useHistory } from "react-router-dom";
import { CellProps } from "react-table";
import IconTrash from "../../icons/IconTrash";
import IconEdit from "../../icons/IconEdit";
import { ColumnSetting } from "../../components/IndexCard.types";
import IconFileInfo from "../../icons/IconFileInfo";
import IconPrinter from "../../icons/IconPrinter";
import { IconDownload } from "@tabler/icons";


export const recentlyOpenedColumns = [


    {
        Header: "Ap Number",
        accessor: (row: ApplicationInspection) => row.application.apnumber,
    },
    {
        Header: "PPI-Portal ID",
        id: "inspectionNumber",
        accessor: (row: ApplicationInspection) => row.applicationInspectionId,
    },
    {
        Header: "Address",
        id: "address",
        accessor: (row: ApplicationInspection) =>
        (row.application.propertyStreetAddress + ', ' + row.application.propertyCity + ', '
         + row.application.propertyState +  ', ' + row.application.propertyZipCode) ?? 0,
    },
    {
        Header: "Actions",
        id: "actions",
        accessor: (row: ApplicationInspection) =>
        (
            <>
                <div className="row">
                    <div className="col-sm-4">
                        <a title="Open" href={"/inspectionDetails/" + row.applicationInspectionId} >
                            <IconEdit />
                        </a>
                    </div>
                    {/* <div className="col-sm-4">
                        <a title="Delete" href={"/inspectionDetails/" + row.applicationId} >
                            <IconTrash />
                        </a>
                    </div> */}
                </div>                
            </>
        ),
    },
];

export const submittedColumns = [


    {
        Header: "Ap Number",
        accessor: (row: ApplicationInspection) => row.application.apnumber,
        // Cell: ({ value }: CellProps<ApplicationDetails>) => {
        //     return <Link to={`/inspectionDetails/${applicationId}`}>{value}</Link>;
        // },
    },
    {
        Header: "EHD-Inspection",
        id: "ehdinspectionNumber",
        accessor: (row: ApplicationInspection) => row.ehdinspectionNumber,
    },
    {
        Header: "Approved Date",
        id: "inspectionApprovedDate",
        accessor: (row: ApplicationInspection) => new Date(row.inspectionApprovedDate ?? 0),
        Cell: ({ value }: { value?: Date }) =>
            value ? new Date(value).toLocaleDateString() : null
    },
    {
        Header: "Address",
        id: "address",
        accessor: (row: ApplicationInspection) =>
         (row.application.propertyStreetAddress + ', ' + row.application.propertyCity + ', '
          + row.application.propertyState +  ', ' + row.application.propertyZipCode) ?? 0,
    },
    {
        Header: "Actions",
        id: "actions",
        accessor: (row: ApplicationInspection) =>
        (
            <>
                <div className="row">
                    <div className="col-sm-4">
                        <a title="View" href={`/summaryView/?applicationId=${row.applicationId}&inspectionId=${row.applicationInspectionId}` } >
                            <IconFileInfo />
                        </a>
                    </div>
                    {/* <div className="col-sm-4">
                        <a title="Download" href={"/inspectionDetails/" + row.applicationId} >
                            <IconDownload />
                        </a>
                    </div>
                    <div className="col-sm-4">
                        <a title="Print" onClick={window.print}>
                            <IconPrinter />
                        </a>
                    </div> */}
                </div>                
            </>
        ),
    },
];
